import { render, staticRenderFns } from "./GroupsSelect.vue?vue&type=template&id=09c64191&scoped=true"
import script from "./GroupsSelect.vue?vue&type=script&lang=js"
export * from "./GroupsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c64191",
  null
  
)

export default component.exports